export default {
  /* -------------------------------------------------------------------------- */
  /*                             Retailer List State                            */
  /* -------------------------------------------------------------------------- */
  loading: false,
  listLoading: false,
  RetailerRecords: [],
  total: 0,
  FilteredCount: 0,
  /* -------------------------------------------------------------------------- */
  /*                            Create Retailer State                           */
  /* -------------------------------------------------------------------------- */
  createLoading: false,
  /* -------------------------------------------------------------------------- */
  /*                             Edit Retailer State                            */
  /* -------------------------------------------------------------------------- */
  editLoading: false,
}
